import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toHandlers as _toHandlers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "flex flex-col mt-8" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-gray-500" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" The default email to contact is ")
const _hoisted_5 = { class: "text-black" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text-gray-500" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Emails will be sent to ")
const _hoisted_10 = { class: "text-black" }
const _hoisted_11 = { class: "flex flex-row flex-wrap" }
const _hoisted_12 = { class: "mr-4" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-5 w-5 text-primary",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "flex flex-col mt-8" }
const _hoisted_17 = { class: "flex flex-row items-center" }
const _hoisted_18 = ["value"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "text-error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.default_contact.show_email && _ctx.contacts.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.default_contact.email), 1),
            _hoisted_6
          ])
        ]))
      : (!_ctx.default_contact.show_email && _ctx.contacts.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.default_email), 1)
            ])
          ]))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contacts, (email, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          class: "flex flex-row bg-primary-light text-primary rounded-full py-2 px-4 mx-1 mb-2"
        }, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(email), 1),
          _createElementVNode("button", {
            onClick: ($event: any) => (_ctx.removeContact(i))
          }, _hoisted_15, 8, _hoisted_13)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("input", _mergeProps(_toHandlers(_ctx.validationListeners), {
          value: _ctx.email,
          placeholder: "Email",
          type: "text",
          class: "bg-background p-4 rounded focus:outline-none focus:ring-2 focus:ring-black focus:bg-white"
        }), null, 16, _hoisted_18),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addMail && _ctx.addMail(...args))),
          disabled: _ctx.isError || _ctx.email === '',
          class: "btn-filled-sm ml-4"
        }, " Add ", 8, _hoisted_19)
      ]),
      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.errorMessage), 1)
    ])
  ]))
}